import { ADMIN_SET_CHANNELS, ADMIN_SET_POLICIES, ADMIN_IS_LOADING } from './actions';

export const AdminReducer = (state = { policies: [], channels: [], loading: true }, action) => {
  switch (action.type) {
    case ADMIN_SET_POLICIES:
      return {
        ...state,
        policies: action.payload.policies,
        loading: false,
      };

    case ADMIN_SET_CHANNELS:
      return {
        ...state,
        channels: action.payload.channels,
      };

    case ADMIN_IS_LOADING:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};
